<template>
    <div id = "split-hero">
        <div class = "first-layer">
            <div class = "main">
                <router-link :to="computePath('about#main')" class = "split-hero-title"> MAIN </router-link>
            </div>
            <div class = "side">
                <router-link :to="computePath('about#side')" class = "split-hero-title"> SIDE </router-link>
            </div>
        </div>
        <div class = "second-layer">
            <div class = "logo-container is-hidden-mobile">
                <div class = "logo">
                    <img src="https://i.imgur.com/OQxMO8e.png" class = "logo-img">
                    <div class = "split-hero-title logo-info" v-html="$t('home.splitHero.elipsis.info1')"></div>
                    <div class = "split-hero-title logo-info" v-html="$t('home.splitHero.elipsis.info2')"></div>
                </div>
            </div>
            <router-link class="button" :to="computePath('register')"> Apply! </router-link>
        </div>
    </div>
</template>

<script>
import pathPrefix from '@/pathPrefix'

export default {
    data() {
        return {
            img: require('@/assets/images/logoBlack.png')
        }
    },
    methods: {
        computePath(path) {
            return `${pathPrefix}/${path}`;
        }
    }
}
</script>

<style lang="scss" scoped>
#split-hero {
    height: 100vh;
    display: flex;
    position: relative;
    justify-content: center;
}

.first-layer {
    display: flex;
    height: 100%;
    width: 100%;
    z-index: 0;
}

.second-layer {
    position: absolute;
    display: flex;
    height: 100vh;
    width: 400px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1;
    background-color: transparent;
}

.side {
    background-image: url("https://i.imgur.com/uD0rfRt.png");
    background-size: cover;
    height: 100vh;
    width: 50%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 50px;
}

.main {
    background-image: url("https://i.imgur.com/XvIuFG3.png");
    background-size: cover;
    height: 100vh;
    width: 50%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 50px;
}

.split-hero-title {
    font-size: 80px;
    font-weight: bold;
}

.logo {
    background-color: #fff;
    border-radius: 50%;
    height: 300px;
    width: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    transition: 0.4s all;
    left: 0;
    right: 0;

    &-info {
        display: none;
        font-size: 18px;
        padding: 0 50px 0 50px;
        width: 550px;
        text-align: center;
    }

    &-info:first-of-type {
        margin-bottom: 20px;
    }

    &-container {
        height: 400px;
    }

    &-img {
        width: 300px;
    }

    &:hover {
        height: 400px;
        width: 600px;
    }

    &:hover &-img {
        display: none;
    }

    &:hover &-info {
        display: flex;
    }
}

.button {
    position: relative;
    top: 50px;
    width: 250px;
    height: 80px;
    font-size: 32px;
    background-color: #000;
}


@media screen and (max-width: 600px) {
    #split-hero, .first-layer, .second-layer {
        flex-direction: column;
    }

    .main, .side {
        width: 100%;
        justify-content: center;
        padding: 0; 
    }

    .second-layer {
        justify-content: center;
        align-items: center;
        width: 100%;
    }

    .button {
        top: 0;
    }   
}
</style>
